import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "../../../../components/UI/Avatar";
import { Loader2, MessageCircle } from "lucide-react";
import { formatShortDate } from "../../utils/relativeTime";
import { cn } from "../../../../utils/utils";

/**
 * Card lời mời kết bạn ĐÃ NHẬN — kích thước lớn, có khu vực preview
 * "lời chào" + 2 button hành động.
 */
const ReceivedInvitationCard = ({
  avatar,
  name,
  source = "Từ số điện thoại",
  createdAt,
  message,
  onAccept,
  onReject,
  onOpenChat,
  pending = false,
}) => {
  return (
    <div className="bg-white border border-gray-200 rounded-xl p-4 flex flex-col gap-3 shadow-sm hover:shadow-md transition-shadow">
      <div className="flex items-start gap-3">
        <Avatar className="h-11 w-11 shrink-0">
          <AvatarImage src={avatar} alt={name} />
          <AvatarFallback>{name?.charAt(0) || "?"}</AvatarFallback>
        </Avatar>
        <div className="min-w-0 flex-1">
          <div className="font-semibold text-[14px] text-gray-900 truncate">
            {name || "(Không tên)"}
          </div>
          <div className="text-[12px] text-gray-500 mt-0.5 truncate">
            {formatShortDate(createdAt)} • {source}
          </div>
        </div>
        {onOpenChat && (
          <button
            onClick={onOpenChat}
            className="text-gray-400 hover:text-indigo-600 p-1 rounded transition-colors"
            title="Mở chat"
          >
            <MessageCircle size={16} />
          </button>
        )}
      </div>

      <div className="border border-gray-200 rounded-lg bg-gray-50/50 px-3 py-2 text-[13px] text-gray-700 max-h-[64px] overflow-y-auto leading-snug">
        {message || (
          <span className="italic text-gray-400">
            Không có lời chào kèm theo.
          </span>
        )}
      </div>

      <div className="grid grid-cols-2 gap-2">
        <button
          onClick={onReject}
          disabled={pending}
          className={cn(
            "h-9 rounded-md bg-gray-100 hover:bg-gray-200 text-gray-700 text-[13px] font-medium transition-colors inline-flex items-center justify-center gap-1.5",
            pending && "opacity-60 cursor-not-allowed",
          )}
        >
          {pending && <Loader2 size={13} className="animate-spin" />}
          Từ chối
        </button>
        <button
          onClick={onAccept}
          disabled={pending}
          className={cn(
            "h-9 rounded-md bg-indigo-50 hover:bg-indigo-100 text-indigo-700 text-[13px] font-medium transition-colors inline-flex items-center justify-center gap-1.5",
            pending && "opacity-60 cursor-not-allowed",
          )}
        >
          {pending && <Loader2 size={13} className="animate-spin" />}
          Đồng ý
        </button>
      </div>
    </div>
  );
};

export default ReceivedInvitationCard;
